import type { HTMLAttributes } from 'react';
import { useSiteContext, useTranslation } from '@eti/providers';
import { screenReadersOnlyStyles } from '../../utils/styleUtils';
import type { DateInput, TimeFormat } from './types';
import { getDateTime, getTimeLabel } from './utils/time-utils';

interface TimeProps extends Omit<HTMLAttributes<HTMLTimeElement>, 'aria-label' | 'dateTime'> {
  date: DateInput;
  format?: TimeFormat;
  screenReaderTextKey?: string;
}

const Time = ({ children, date, format, screenReaderTextKey, ...props }: TimeProps) => {
  const { t } = useTranslation();
  const {
    language: { locale },
  } = useSiteContext();

  const dateTime = getDateTime(date);
  const timeLabel = getTimeLabel(locale, date, format);

  return (
    <>
      <time aria-hidden="true" dateTime={dateTime} {...props}>
        <bdi>{children}</bdi>
      </time>
      <span className={screenReadersOnlyStyles}>
        {screenReaderTextKey ? t(screenReaderTextKey, timeLabel) : timeLabel}
      </span>
    </>
  );
};

export default Time;
